module.exports = __webpack_public_path__ + "static/media/ic_favorite_full.8df83cbd.svg";